export interface PagePreview {
  src: string
  alt: string
}

export const pagePreviews: PagePreview[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/cg6bCG63HmSX1NhiTNzkRm/WhatsApp_Image_2026-09-14_at_11.46.58_PM.jpg',
    alt: 'Página explicando qué es un agente deportivo: qué hace y qué no hace',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qupgwov5rxNwvSWZwd3qiF/WhatsApp_Image_2026-09-14_at_11.45.47_PM.jpg',
    alt: 'Página sobre la educación como estructura del plan A y cómo equilibrar escuela y entrenamientos',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rhmE9GLdfB2B8WRdGHdWDR/WhatsApp_Image_2026-09-14_at_11.45.46_PM.jpg',
    alt: 'Página del capítulo 11: El mapa de carrera, objetivos claros de los ocho a los dieciocho años',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/f11MrRXehj1gGJJWsdZsvV/WhatsApp_Image_2026-09-14_at_11.45.47_PM_(2).jpg',
    alt: 'Página sobre agentes con licencia FIFA, representantes, observadores e intermediarios',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/akxHvH966KFGtNnNRkj9Cm/WhatsApp_Image_2026-09-14_at_11.45.47_PM_(3).jpg',
    alt: 'Página con la transición a Reserva y qué miran los clubes en el primer contrato profesional',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vWZvFAqEmKM88Xy9ZnJK9A/WhatsApp_Image_2026-09-14_at_11.45.47_PM_(1).jpg',
    alt: 'Página sobre pases, cesiones y transferencias: jugador registrado vs. jugador libre',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gNnBPbjE3kZmUu8ykN5TYu/WhatsApp_Image_2026-09-14_at_11.45.48_PM.jpg',
    alt: 'Página sobre cómo varían los reglamentos según competencia y categoría, de Novena a Reserva',
  },
]
